exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.list-move{transition:transform .3s,opacity .4s\n}\n.list-item{display:inline-block;margin-right:10px\n}\n.list-enter-active,.list-leave-active{transition:opacity .4s\n}\n.list-enter,.list-leave-to{opacity:0\n}", ""]);

// exports
